import { HttpParams } from '@angular/common/http'
import { Component, Input, OnDestroy, OnInit, WritableSignal } from '@angular/core'
import { FormsModule } from '@angular/forms'
import { WjGridModule } from '@grapecity/wijmo.angular2.grid'
import { WjGridFilterModule } from '@grapecity/wijmo.angular2.grid.filter'
import { WjInputModule } from '@grapecity/wijmo.angular2.input'

import {
    AutoSizeDirective,
    BaseComponent,
    FeatureType,
    Grid,
    ModalSize,
    QualityControlSoilResult,
    VpJob,
} from '../../../shared'
import { ActionToolbarButtonsComponent } from '../../../shared/reusable-components/action-toolbar-buttons/action-toolbar-buttons.component'
import { ActionToolbarCount } from '../../../shared/reusable-components/action-toolbar-count/action-toolbar-count.component'
import { ActionToolbarSearchComponent } from '../../../shared/reusable-components/action-toolbar-search/action-toolbar-search.component'
import { SoilResultModalComponent } from './soil-result-modal.component'

@Component({
    selector: 'app-quality-control-soil-result',
    templateUrl: './soil-result.component.html',
    standalone: true,
    imports: [
        FormsModule,
        WjGridModule,
        WjGridFilterModule,
        WjInputModule,
        ActionToolbarCount,
        ActionToolbarButtonsComponent,
        ActionToolbarSearchComponent,
        AutoSizeDirective,
    ],
})
export class SoilResultComponent extends BaseComponent implements OnInit, OnDestroy {
    @Input() selectedJob!: WritableSignal<string>
    @Input() allJobs: VpJob[] = []

    grid: Grid<QualityControlSoilResult>

    constructor() {
        super()
        this.grid = new Grid<QualityControlSoilResult>(this.services)
            .setupModalEditing(
                this.services.data.qualityControlSoilResults,
                'Soil / Density Result',
                SoilResultModalComponent,
                () => QualityControlSoilResult.createNew(),
                this,
                ModalSize.large,
            )
            .filterBy(item => [
                item.reportNumber,
                item.labName,
                item.generalLocation,
                item.inspector,
                item.reportSource,
                item.testMethod,
            ])
            .withColumnFilters()
            .isReadOnly(true)
            .wrapColumnHeaders()

        this.grid.itemAdded.on(this.handleItemAdded.bind(this))
        this.grid.modified.on(this.refreshData.bind(this))
    }

    get canEdit() {
        return this.services.authentication.hasFeature([FeatureType.FieldToolsPlansAndSpecsEdit])
    }

    ngOnInit() {
        // no additional init
    }

    ngOnDestroy(): void {
        this.grid.itemAdded.off(this.handleItemAdded.bind(this))
        this.grid.modified.off(this.refreshData.bind(this))
        this.grid.destroy()
    }

    loadSoilResultData(jobId: string) {
        if (!jobId || jobId === '') {
            this.grid.items = []
            return
        }

        const params = new HttpParams().set('jobId', jobId)
        this.services.data.get<QualityControlSoilResult[]>('api/QualityControlSoilResult/GetByJob', params).subscribe({
            next: (result: QualityControlSoilResult[]) => {
                this.grid.items = result || []
            },
            error: () => {
                this.services.notification.error('Failed to load soil/density test results')
                this.grid.items = []
            },
        })
    }

    handleItemAdded(item: QualityControlSoilResult) {
        item.job = this.selectedJob()
    }

    refreshData() {
        const jobId = this.selectedJob()
        if (jobId && jobId !== '') {
            this.loadSoilResultData(jobId)
        }
    }

    onGridInitialized() {
        // Grid initialized
    }
}
